import {BlobRepository} from "./repositories/blob/BlobRepository";

export const blobRepo = new BlobRepository();
